export default __webpack_public_path__ + "static/media/logo.d01e7bb7.svg";